import React, { useId } from "react";

/**
 * Triguna Solutions logo mark.
 *
 * Concept: "Triguna" = three. Three connected nodes form a delta/network —
 * representing AI, cloud, and data connectivity (our core services). Rendered
 * on a rounded brand-gradient tile so it stays legible on any background.
 */
const LogoMark = ({ className = "h-9 w-9" }) => {
  const id = useId();
  const gradId = `tg-grad-${id}`;

  return (
    <svg
      viewBox="0 0 40 40"
      className={className}
      role="img"
      aria-label="Triguna Solutions logo"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#C026D3" />
        </linearGradient>
      </defs>

      {/* Tile */}
      <rect x="0" y="0" width="40" height="40" rx="10" fill={`url(#${gradId})`} />

      {/* Connecting lines (network / delta) */}
      <g stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" opacity="0.9">
        <line x1="20" y1="12" x2="12" y2="28" />
        <line x1="20" y1="12" x2="28" y2="28" />
        <line x1="12" y1="28" x2="28" y2="28" />
      </g>

      {/* Nodes — top node accented gold */}
      <circle cx="20" cy="12" r="3.4" fill="#F59E0B" stroke="#FFFFFF" strokeWidth="1.2" />
      <circle cx="12" cy="28" r="3" fill="#FFFFFF" />
      <circle cx="28" cy="28" r="3" fill="#FFFFFF" />
    </svg>
  );
};

export default LogoMark;
